var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcon = function SvgIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3312 2.00159H1.66455C0.328453 2.00159 0.333985 3.33598 0.333985 3.33598L0.333986 14.0026C0.333986 15.3349 1.66455 15.3349 1.66455 15.3349H12.3312C12.3312 15.3349 13.6673 15.336 13.6673 14.0026V3.33598C13.6673 3.33598 13.6646 2.00159 12.3312 2.00159ZM1.66642 3.99971C1.66642 3.33491 2.33309 3.33304 2.33309 3.33304H11.6664C11.6664 3.33304 12.3331 3.33304 12.3331 3.99971V13.333C12.3331 13.9997 11.6664 13.9997 11.6664 13.9997H2.33309C2.33309 13.9997 1.66642 13.9997 1.66642 13.333V3.99971Z",
    fill: "#777776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00203 7.3337C0.633845 7.3337 0.335368 7.03522 0.335368 6.66703C0.335368 6.29884 0.633845 6.00037 1.00203 6.00037H13.002C13.3702 6.00037 13.6687 6.29884 13.6687 6.66703C13.6687 7.03522 13.3702 7.3337 13.002 7.3337H1.00203Z",
    fill: "#777776"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00065 1.33464C9.00065 0.966446 9.29913 0.667969 9.66732 0.667969C10.0355 0.667969 10.334 0.966446 10.334 1.33464V4.0013C10.334 4.36949 10.0355 4.66797 9.66732 4.66797C9.29913 4.66797 9.00065 4.36949 9.00065 4.0013V1.33464Z",
    fill: "#777776"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66732 1.33464C3.66732 0.966446 3.96579 0.667969 4.33398 0.667969C4.70217 0.667969 5.00065 0.966446 5.00065 1.33464V4.0013C5.00065 4.36949 4.70217 4.66797 4.33398 4.66797C3.96579 4.66797 3.66732 4.36949 3.66732 4.0013V1.33464Z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon.6f100432.svg";
export { ForwardRef as ReactComponent };